import React, { useState, useEffect } from 'react';

interface TypingEffectProps {
  messages: string[];
  speed?: number;
  delay?: number;
}

const TypingEffect: React.FC<TypingEffectProps> = ({ messages, speed = 50, delay = 2000 }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [messageIndex, setMessageIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    
    const currentMessage = messages[messageIndex];
    
    if (!isDeleting && charIndex < currentMessage.length) {
      // Typing
      timeoutId = setTimeout(() => {
        setDisplayedText(currentMessage.substring(0, charIndex + 1));
        setCharIndex(charIndex + 1);
      }, speed);
    } else if (isDeleting && charIndex > 0) {
      // Deleting
      timeoutId = setTimeout(() => {
        setDisplayedText(currentMessage.substring(0, charIndex - 1));
        setCharIndex(charIndex - 1);
      }, speed / 2);
    } else if (!isDeleting && charIndex === currentMessage.length) {
      // Finished typing, wait then start deleting
      timeoutId = setTimeout(() => setIsDeleting(true), delay);
    } else if (isDeleting && charIndex === 0) {
      // Finished deleting, move to next message
      setIsDeleting(false);
      setMessageIndex((messageIndex + 1) % messages.length);
    }

    return () => clearTimeout(timeoutId);
  }, [charIndex, isDeleting, messageIndex, messages, speed, delay]);

  return (
    <p className="text-xl md:text-2xl text-gray-700 font-light">
      {displayedText}
      <span className="inline-block w-1 h-8 bg-ariyva-electric ml-1 animate-pulse"></span>
    </p>
  );
};

export default TypingEffect;
